import { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import { AppIcon } from '../AppIcon'
import Typography from '@mui/material/Typography'

const SuspensePanel = () => {
  const [shouldRender, setShouldRender] = useState(false)
  useEffect(() => {
    const timeout = setTimeout(() => {
      setShouldRender(true)
    }, 100)
    return () => {
      clearTimeout(timeout)
    }
  }, [])
  if (!shouldRender) {
    return null
  }
  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'pageBackground',
        gap: 1,
      }}
    >
      <AppIcon sx={{ width: '5vw' }} />
      <Typography>Loading...</Typography>
    </Box>
  )
}

export default SuspensePanel
